export default {
    /* reserve status API call */
    CAR_RESERVE_STATUS: 'CAR_RESERVE_STATUS',
    RESET_CAR_RESERVE_STATUS: 'RESET_CAR_RESERVE_STATUS'
};
